import { bool, func, number, shape, string } from "prop-types";
import React from "react";

import { useAddColumn } from "Boards/APIReactQuery/queries";
import useGroupOrSignupID from "Boards/useGroupOrSignupID";
import classNames from "classnames";

import {
  ExtendedFieldOption,
  ExtendedFieldOptionText,
  IconContainer,
} from "./ProfileFieldTab";

SacramentFieldOption.propTypes = {
  boardID: number,
  orderBy: number,
  sacramentName: string,
  field: shape({
    title: string,
    networkFieldID: number,
    isCurrentlyOnBoard: bool,
    defaultFieldTypeInstanceMapping: string,
    columnType: number,
  }),
  refreshBoardData: func,
  isSavingSelection: bool,
  setIsSavingSelection: func,
};

export default function SacramentFieldOption({
  field,
  sacramentName,
  boardID,
  orderBy,
  refreshBoardData,
  isSavingSelection,
  setIsSavingSelection,
}) {
  const groupOrSignupID = useGroupOrSignupID();

  const { mutate, isLoading } = useAddColumn({
    boardID,
    networkFieldID: field.networkFieldID,
    onSuccess: (res) => {
      // console.log("success", res);
      setIsSavingSelection(false);
      refreshBoardData();
    },
    onError: (err) => {
      console.log(err);
    },
  });

  const handleClick = (field) => {
    setIsSavingSelection(true);
    let postData = {
      columnEntityID: field.networkFieldID,
      columnType: field.columnType,
      orderBy: orderBy,
      title: `${sacramentName} ${field.title}`,
      ...groupOrSignupID,
    };
    mutate({ postData });
  };

  if (!field) return null;

  return (
    <ExtendedFieldOption
      key={`${field?.networkFieldID}`}
      type="button"
      onClick={() => {
        handleClick(field);
      }}
      disabled={field?.isCurrentlyOnBoard || isLoading || isSavingSelection}
      className={classNames({
        isCurrentlyOnBoard: field?.isCurrentlyOnBoard,
      })}
    >
      <IconContainer className={`fa-${field?.icon}`} />
      <ExtendedFieldOptionText>{field?.title}</ExtendedFieldOptionText>
    </ExtendedFieldOption>
  );
}
